/** Mirrors `SubscriptionPlanDto` on the backend. */
export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string | null;
  /** Billing cadence: "month", "year", "lifetime". */
  interval: string | null;
  price: number | null;
  /** The struck-through "was" price, when the plan advertises one. */
  originalPrice: number | null;
  currency: string | null;
  /** Marketing label shown on the plan card, e.g. "2 months Free". */
  badge: string | null;
  isActive: boolean;
  isPopular: boolean;
  sortOrder: number;
  features: string[];
  createdAt: string | null;
  /** Every subscription ever created on this plan. */
  subscriberCount: number;
  /** Those currently in force. */
  activeSubscriberCount: number;
  /** Recurring revenue normalised to a month; 0 for a plan that never renews. */
  monthlyRevenue: number;
}

/**
 * The cadence as a column reads: "Monthly", "Yearly", "One-time". Unknown
 * cadences are shown as given rather than dropped.
 */
export function intervalLabel(interval: string | null): string {
  const normalized = interval?.trim().toLowerCase();

  if (!normalized) {
    return '—';
  }

  const labels: Record<string, string> = {
    day: 'Daily',
    daily: 'Daily',
    week: 'Weekly',
    weekly: 'Weekly',
    month: 'Monthly',
    monthly: 'Monthly',
    year: 'Yearly',
    yearly: 'Yearly',
    lifetime: 'One-time',
    once: 'One-time',
  };

  return labels[normalized] ?? normalized;
}
